const clientConfig = {
  siteUrl: "//3for3networking.com/backend/wp-json/",
  meetUrl: "https://video.3for3networking.com",
  pusherAppKey: "37964f12a6f45f6ca23b",
  pusherAppCluster: "us2",
};

export default clientConfig;

export const secretPass = "XkhZG4fW2t2W";

export const strip_public_key =
  "pk_live_51RH1WgLbm111KlsMXAp2GzYYU7r1ZNZJanAI4ZasADfIdCjZ7Sufp9AElXzW6ZdOj2umxa2XjsrqAa7In6w66uvY00X1TBafXL";

export const strip_test_public_key =
  "pk_test_51RH1WgLbm111KlsMXWvwSUfDRCINHvXNl1N4E9OgEPz4q7cszyVg4vbLApbFmY608bcQCez9fCDK2PnR0BQMQYIw00uXhnlORS";